"use client";

import { useState } from "react";

export default function ToggleButton({
  defaultChecked = false,
  onChange,
  disabled = false,
  className = "",
}) {
  const [isChecked, setIsChecked] = useState(defaultChecked);

  const handleToggle = () => {
    if (disabled) return;
    const newChecked = !isChecked;
    setIsChecked(newChecked);
    if (onChange) {
      onChange(newChecked);
    }
  };

  return (
    <button
      type="button"
      role="switch"
      aria-checked={isChecked}
      disabled={disabled}
      onClick={handleToggle}
      className={`toggle-button ${isChecked ? "toggle-checked" : ""} ${disabled ? "toggle-disabled" : ""} ${className}`}
    >
      <span className="toggle-slider" />
    </button>
  );
}
